var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "div",
        {
          staticClass: "go-top",
          staticStyle: { display: "block", opacity: "0.801472" },
          on: { click: _vm.scrollToTopApp },
        },
        [
          _c(
            "svg",
            {
              staticClass: "feather feather-arrow-up",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
              },
            },
            [
              _c("line", { attrs: { x1: "12", y1: "19", x2: "12", y2: "5" } }),
              _c("polyline", { attrs: { points: "5 12 12 5 19 12" } }),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }